import { render, staticRenderFns } from "./GridPagination.vue?vue&type=template&id=2e2aac4a&"
import script from "./GridPagination.vue?vue&type=script&lang=js&"
export * from "./GridPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports